import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class UserCreateForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'password',
			value => {
				return value.trim().match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(^.{12,}$)/);
			},
			'PASSWORDMINREQUIREMENTS'
		);
		Validator.register(
			'username',
			value => {
				return !value.match(/[^A-Za-z0-9]+/);
			},
			'INVALIDUSERNAME'
		);
		return {
			fields: [
				{
					name: 'organizationId',
					label: 'LOGINFORM.ORGANIZATION',
				},
				{
					name: 'userName',
					label: 'LOGINFORM.USERNAME',
					rules: 'required|string|between:3,50|username',
				},
				{
					name: 'email',
					label: 'LOGINFORM.EMAIL',
					rules: 'required|email|string',
				},
				{
					name: 'countryId',
					label: 'LOGINFORM.COUNTRYCODE',
					rules: 'required',
				},
				{
					name: 'userPhone',
					label: 'LOGINFORM.USERPHONE',
					rules: 'required',
				},
				{
					name: 'password',
					label: 'LOGINFORM.PASSWORD',
					rules: ['required', 'string', 'password'],
					type: 'password',
				},
				{
					name: 'confirmPassword',
					label: 'LOGINFORM.CONFIRMPASSWORD',
					rules: 'required|string|same:password',
					type: 'password',
				},
				{
					name: 'roleIds',
					label: 'LOGINFORM.USERROLES.LABEL',
					placeholder: 'LOGINFORM.USERROLES.PLACEHOLDER',
					rules: 'required',
				},
				{
					name: 'apiKey',
					label: 'LOGINFORM.PRINTNODE.APIKEY',
				},
				{
					name: 'labelPrinterId',
					label: 'LOGINFORM.PRINTNODE.LABELPRINTER',
				},
				{
					name: 'packingSlipPrinterId',
					label: 'LOGINFORM.PRINTNODE.PACKINGSLIPPRINTER',
				},
				{
					name: 'upcLabelPrinterId',
					label: 'LOGINFORM.PRINTNODE.UPCLABELPRINTER',
				},
				{
					name: 'apiSecret',
					label: 'LOGINFORM.APISECRET',
				},
			],
		};
	}
}
